import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./productman.css"
import { Link } from 'react-router-dom';

import Manufactureimg from "../../../assets/images/Industry Page/product-manufacturer.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-manufacture";
import Swiper from "../Bfsi Solution/swiper";
import SEO from "../../seo";

export default function ProductManu() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Product Manufacturer"
                description="Industries Take Advantage of The Best Product Manufacturer Software Development At Horizon WebInfo Pvt Ltd, we understand the dynamic landscape of digital commerce. Our mission is to empower product manufacturers to thrive in the online sphere through innovative website development services. Production Planning and Scheduling Details: Efficiently plan production schedules, allocate resources, and optimize workflows [&hellip;]"
                canonical="https://www.hwplindia.com/industries/product-manufacturer/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-product-manufacturer-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Product Manufacturer</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Product Manufacturer</li>
                    </ul>
                </div>
            </section>
             <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of The Best Product Manufacturer Software Development</h3>
                                <p className='email'>
                                  At Horizon Webinfo Pvt. Ltd. we understand the dynamic landscape of digital commerce. Our mission is to empower product manufacturers to thrive in the online sphere through innovative website development services.
                                </p>
                            </section>

                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Production Planning and Scheduling</h3>
                                    <p>
                                        <strong>Details:</strong> Efficiently plan production schedules, allocate resources, and optimize workflows to meet demand.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Minimize downtime, reduce costs, and enhance overall production efficiency.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Inventory Management</h3>
                                    <p>
                                        <strong>Details:</strong> Track and manage inventory levels in real-time, automate reordering, and prevent stockouts or overstock situations.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve inventory accuracy, reduce holding costs, and enhance order fulfillment.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Quality Control and Assurance</h3>
                                    <p>
                                        <strong>Details:</strong> Implement quality checks at various stages of production, track defects, and ensure adherence to quality standards.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve product quality, reduce defects, and maintain compliance with industry regulations.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Supply Chain Management</h3>
                                    <p>
                                        <strong>Details:</strong> Streamline procurement processes, manage supplier relationships, and optimize the entire supply chain.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Reduce lead times, enhance collaboration with suppliers, and minimize supply chain risks.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Shop Floor Automation</h3>
                                    <p>
                                        <strong>Details:</strong> Implement automation for routine tasks on the shop floor, including data collection, machine monitoring, and process control.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Increase operational efficiency, reduce manual errors, and improve overall productivity.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Equipment Maintenance and Monitoring</h3>
                                    <p>
                                        <strong>Details:</strong> Schedule and track equipment maintenance, monitor equipment health, and predict maintenance needs.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Minimize downtime, extend equipment lifespan, and reduce unexpected breakdowns.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Real-Time Data Analytics</h3>
                                    <p>
                                        <strong>Details:</strong> Utilize data analytics to gain insights into production performance, identify trends, and make informed decisions.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improve decision-making, optimize processes, and identify areas for continuous improvement.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Collaborative Workflows</h3>
                                    <p>
                                        <strong>Details:</strong> Facilitate communication and collaboration among teams, departments, and stakeholders involved in the manufacturing process.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Enhance transparency, reduce miscommunication, and improve overall collaboration.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Regulatory Compliance Management</h3>
                                    <p>
                                        <strong>Details:</strong> Monitor and ensure compliance with industry regulations and standards relevant to product manufacturing.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Mitigate legal risks, ensure product quality, and maintain a positive reputation in the market.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Integration with ERP Systems</h3>
                                    <p>
                                        <strong>Details:</strong> Seamlessly integrate with enterprise resource planning (ERP) systems for comprehensive business management.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Streamline data flow, enhance cross-functional collaboration, and provide a unified view of business operations.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best Shipping & Logistics Software Development Company
                                    </h2>

                                    <p>
                                        At Horizon Webinfo Pvt. Ltd. we specialize in crafting cutting-edge logistics solutions that cater to a diverse range of industries. Our innovative web and application development services are tailored to streamline operations, optimize efficiency, and transform the way businesses manage their logistics.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Manufactureimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}